import { FC } from 'react'

import { Top3 } from './Top3.tsx'
import { MonthGroup } from './MonthGroup'
import Style from './HallOfFame.module.scss'

interface Props {
    data: hallOfFame[][]
    selectedTime: string
}

export const HallOfFame: FC<Props> = ({ data, selectedTime }) => {
    if (!data || !data.length) {
        return (
            <p
                style={{
                    color: '#fff',
                    textAlign: 'center',
                    paddingTop: '20px',
                }}
            >
                Hall of Fame will be available soon !{' '}
            </p>
        )
    }
    return (
        <div className={Style.contentTab}>
            <Top3 hallOfFameData={data[0]} />
            <div style={{ height: '10px' }} />
            {data.slice(1).map((items, index) => {
                return <MonthGroup key={index} hallOfFameData={items} />
            })}
        </div>
    )
}
